import React from "react";
import BreadCrumbComp from "../../../components/breadCrumb";
import SimpleTable from "../../../components/tables/simpleTable";
import { useState } from "react";
import { icons } from "../../../constants";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import VerificationModal from "../../../components/modals/verificationModal";
import LaddaButton from "../../../components/buttons/laddaButton";
import { useSelector } from "react-redux";
import { canManageServiceSuppliers } from "../../../constants/supplierRoles";
import {
  callApiAsync,
  deleteServiceSupplier,
  getCallProcess,
  getServiceSuppliers
} from "../../../services/apiService";
import ToastNotification from "../../../components/toastNotification";
import { Grid } from "@mui/material";
import SimpleSelect from "../../../components/selects/simpleSelect";
import { useForm } from "react-hook-form";

const ServicesSuppliers = () => {
  const [filteredTableData, setFilteredTableData] = useState([]);
  const [filteract, setFilteract] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [openVerification, setOpenVerification] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [process, setProcess] = useState([]);
  const [toastConfig, setToastConfig] = useState({
    severity: "success",
    summary: "",
    detail: ""
  });

  const navigate = useNavigate();
  const userData = useSelector((state) => state.userData.userData);

  const isSupplierManagment = canManageServiceSuppliers(userData.roleList);

  const {
    control,
    handleSubmit,
    formState: { errors },
    getValues,
    setValue,
    watch
  } = useForm({});

  const columns = [
    { field: "supplier_name", header: "Nombre del Proveedor" },
    { field: "nit", header: "NIT" },
    { field: "process_id", header: "", columnType: "hide" },
    { field: "process_name", header: "Proceso al que pertenece" },

    {
      field: "actionButtons",
      columnType: "actionButtons"
    }
  ];

  const buttonsTable = () => {
    return [
      {
        type: "icon",
        icon: !isSupplierManagment ? icons.eye : icons.editBlue,
        onClick: (data) => {
          navigate("/suppliers/services_suppliers/create_new", {
            state: { data: data }
          });
        }
      },
      ...(isSupplierManagment
        ? [
            {
              type: "icon",
              icon: icons.redTrash,
              onClick: (data) => {
                setSelectedData(data);
                handleRemove();
              }
            }
          ]
        : [])
    ];
  };

  const getProcess = async () => {
    callApiAsync(getCallProcess, (data) => {
      setProcess(data);
    });
  };

  const getTableData = async () => {
    await callApiAsync(
      () => getServiceSuppliers(),
      (data) => {
        setTableData(data);
        setFilteredTableData([]);
        setSelectedData(null);
      }
    );
    return;
  };

  const handleRemove = (index) => {
    setOpenVerification(true);
  };

  const handleRemoveConfirmed = async () => {
    await callApiAsync(
      () => deleteServiceSupplier({ id: selectedData.id }),
      (data) => {
        getTableData();
        setSelectedData(null);
        setOpenVerification(false);
        setToastConfig({
          severity: "success",
          summary: "Acción realizada",
          detail: "Se elimino el proveedor con éxito."
        });
        setShowToast(true);
      }
    );
  };

  const handleFilter = () => {
    setFilteract(true);
    const selectedProcess = getValues("process_id");

    if (selectedProcess) {
      const filtered = tableData.filter(
        (item) => item.process_id === selectedProcess
      );
      setFilteredTableData(filtered);
    } else {
      setFilteredTableData([]);
    }
  };

  const handleClearFilters = () => {
    setFilteract(false);
    setFilteredTableData([]);
    setValue("process_id", null);
  };

  useEffect(() => {
    getProcess();
    getTableData();
  }, []);

  return (
    <div>
      <BreadCrumbComp />

      <div className="searchTitle  HContainer j-space-between align-center">
        <h1>PROVEEDOR DE SERVICIOS</h1>

        {isSupplierManagment && (
          <LaddaButton
            variant="contained"
            height={"32px"}
            onClick={() => {
              navigate("/suppliers/services_suppliers/create_new", {
                state: { data: { id: 0 } }
              });
            }}
          >
            <div className="IHContainer align-center">
              <img
                className="btn-icon"
                src={icons.plusIcon}
                alt="icon"
                style={{ marginRight: "10px" }}
              />
              <p className="button_text">Crear Proveedor de Servicios</p>
            </div>
          </LaddaButton>
        )}
      </div>

      <div>
        <SimpleTable
          data={filteract ? filteredTableData : tableData}
          columns={columns}
          text={"Realizar Autoevaluación"}
          isPaginated={true}
          buttons={buttonsTable()}
          globalFilterFields={[
            "supplier_name",
            "nit",
            "process_id",
            "process_name",
            "supplier_evaluation"
          ]}
          headerButton={
            <Grid container justifyContent="center" spacing={2}>
              <Grid item xs={12} md={9.5}>
                <p className="blueLabelForm" style={{ marginLeft: 0 }}>
                  Seleccionar Proceso:
                </p>
                <SimpleSelect
                  name="process_id"
                  control={control}
                  options={process}
                  error={errors.institution}
                  margin={"0"}
                />
              </Grid>
              <Grid item xs={12} sm={2} md={2.5}>
                <div className="IHContainer j-end align-end h-complete">
                  <LaddaButton
                    variant="contained"
                    onClick={() => handleFilter()}
                    margin={"0"}
                  >
                    <img
                      className="btn-icon"
                      src={icons.filterWhite}
                      alt="icon"
                    />
                  </LaddaButton>
                  <LaddaButton
                    variant="contained"
                    onClick={handleClearFilters}
                    margin={"0 0 0 10px"}
                  >
                    <img
                      className="btn-icon"
                      src={icons.clearFilterWhite}
                      alt="icon"
                    />
                  </LaddaButton>
                </div>
              </Grid>
            </Grid>
          }
        />
      </div>
      <VerificationModal
        open={openVerification}
        handleClose={() => setOpenVerification(false)}
        alertText="¿Estás seguro de eliminar este proveedor?"
        onConfirm={handleRemoveConfirmed}
      />
      <ToastNotification
        severity={toastConfig.severity}
        summary={toastConfig.summary}
        detail={toastConfig.detail}
        showToast={showToast}
        setShowToast={setShowToast}
        position="top-right"
      />
    </div>
  );
};

export default ServicesSuppliers;
